import React from 'react';
import { t } from 'i18next';
import ArtisticIcon from './riasec/ArtisticIcon';
import EnterprisingIcon from './riasec/EnterprisingIcon';
import InvestigativeIcon from './riasec/InvestigativeIcon';
import RealisticIcon from './riasec/RealisticIcon';
import SocialIcon from './riasec/SocialIcon';
import ConventionalIcon from './riasec/ConventionalIcon';
import { riasecScoreCopy } from '../../../copy/user-dashboard/riasec-score-copy.json';

export default class BarGroupVertical extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  showIcon = (label, xOffset, yOffset) => {
    switch (label) {
      case riasecScoreCopy.labels[0].name:
        return (
          <RealisticIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      case riasecScoreCopy.labels[1].name:
        return (
          <InvestigativeIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      case riasecScoreCopy.labels[2].name:
        return (
          <ArtisticIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      case riasecScoreCopy.labels[3].name:
        return (
          <SocialIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      case riasecScoreCopy.labels[4].name:
        return (
          <EnterprisingIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      case riasecScoreCopy.labels[5].name:
        return (
          <ConventionalIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
      default:
        return (
          <ArtisticIcon
            xVal={xOffset}
            yVal={yOffset}
            color={this.props.tenant.secondary}
          />
        );
    }
  };

  renderBar = (item, thickness, index) => {
    const nameLabelXOffset = 50;
    const nameLabelYOffset = thickness + 30;
    const iconlXOffset = 5;
    const iconlYOffset = thickness + 10;
    const valueOffset = 15;
    const barColour = index < 3 ? this.props.tenant.primary : '#C1C1C1';
    const lengthScale = (d) => d * 15;
    const length = lengthScale(item.value);

    return (
      <g className="bar-group">
        <text
          className="name-label mobile"
          x={nameLabelXOffset}
          y={nameLabelYOffset}
          alignmentBaseline="middle"
        >
          {t(item.name)}
        </text>
        <rect
          data-cy={`${item.name.replace(/\(|\)/g, '')}-rect`}
          height={thickness}
          width={length}
          fill={barColour}
        />
        {this.showIcon(item.name, iconlXOffset, iconlYOffset)}
        <text
          className="value-label mobile"
          x={length - valueOffset}
          y={18}
          alignmentBaseline="middle"
          data-cy={`${item.name.replace(/\(|\)/g, '')}-value`}
        >
          {item.value}
        </text>
      </g>
    );
  };

  barGroups = (items, thicc, spacing) => {
    const topMargin = 50;
    const xVal = 25;
    return items.map((item, index) => (
      <g
        key={item.name}
        transform={`translate( ${xVal}, ${topMargin + index * spacing})`}
      >
        {this.renderBar(item, thicc, index)}
      </g>
    ));
  };

  render() {
    const { data, thickness, spacing } = this.props;
    return this.barGroups(data, thickness, spacing);
  }
}
